import React from "react"
import Match from "../components/Match"
import { useState, useEffect } from 'react'
import '../css/Dashboard.css'
import { useAuth } from "../contexts/AuthContext"
import { db } from '../firebase'
import '../css/Base.css'
import ConnectionToast from "../components/ConnectionToast"

function Dashboard() {

  const [isLoading, setIsLoading] = useState(true);
  const [loadedDataFromApi, setLoadedDataFromApi] = useState([]);
  const { currentUser } = useAuth()

  // dates can be = 2021-1-1 or 2021-01-01, to avoid errors we will always use the same formating

  function CreateDate(number = 0) {

    var today = new Date();
    var addDays = number

    today.setDate(today.getDate() + addDays);

    var d = today.getDate();
    if (d.toString().length === 1) d = "0" + d.toString()
    var m = today.getMonth() + 1;
    if (m.toString().length === 1) m = "0" + m.toString()
    var y = today.getFullYear();
    if (y.toString().length === 1) y = "0" + y.toString()

    var todayS = `${y}-${m}-${d}`;
    return todayS
  }

  var todayString = CreateDate()
  var inTenDaysString = CreateDate(10)

  useEffect(() => {
    setIsLoading(true);

    var dateLastCall = "";

    db.collection("ExtraInformation").doc("DashboardLastCall")
      .get().then((doc => {

        dateLastCall = doc.data().date;

        //if (true) {
        if (dateLastCall === todayString) {

          localStorage.setItem("ApiOrFirebaseOrNoMatches", "FIREBASE");

          var docRef = db.collection("Fixtures")
          var ArrayIfDataExistInFirebase = [];

          docRef
            .where("date", ">=", todayString)
            .get()
            .then((querySnapshot => {
              querySnapshot.forEach((fixture => {

                db.collection("Players").doc(`${currentUser.uid}`).collection("Favorites").doc(`${fixture.data().id}`)
                  .get().then((docFavorite => {
                    if (docFavorite.exists) {
                      ArrayIfDataExistInFirebase.push(docFavorite.data());

                      if (querySnapshot.size === ArrayIfDataExistInFirebase.length) {
                        setIsLoading(false);
                        setLoadedDataFromApi(ArrayIfDataExistInFirebase);
                      }

                    }
                    else {
                      ArrayIfDataExistInFirebase.push(fixture.data());

                      if (querySnapshot.size === ArrayIfDataExistInFirebase.length) {
                        setIsLoading(false);
                        setLoadedDataFromApi(ArrayIfDataExistInFirebase);
                      }
                    }
                  }))
              }))
            }));
        }
        else {
          localStorage.setItem("ApiOrFirebaseOrNoMatches", "API");

          //fetch(`https://soccer.sportmonks.com/api/v2.0/fixtures/between/2021-12-18/2021-12-18?api_token=oAF3XOevLeC24Zjuzvu56vfOfvyrmHSd11eHr4Ij6ifeJq563NzHeKFrLaJy`
          fetch(`https://soccer.sportmonks.com/api/v2.0/fixtures/between/${todayString}/${inTenDaysString}?api_token=oAF3XOevLeC24Zjuzvu56vfOfvyrmHSd11eHr4Ij6ifeJq563NzHeKFrLaJy`
          )
            .then((response => {
              return response.json();
            }))
            .then((response => {

              // if no opcomming matches ...
              if (response.data === undefined) {
                localStorage.setItem("ApiOrFirebaseOrNoMatches", "NM");
                setIsLoading(false);

                db.collection("ExtraInformation").doc("DashboardLastCall")
                  .set({
                    date: todayString
                  })
              }
              else {

                var TeamCount = response.data.length;
                var TeamsLocalProcessed = 0;
                var TeamsVisitorProcessed = 0;
                var LeaguesProcessed = 0;
                var PredictionsProcessed = 0;
                var FavoriteProcessed = 0;

                //FOREACH to loop over every {} in the []
                response.data.forEach((data) => {

                  var localTeam = data.localteam_id;
                  var visitorTeam = data.visitorteam_id;
                  var fixtureId = data.id;
                  var LeagueId = data.league_id;

                  var docRef1 = db.collection("Teams").doc(`${localTeam}`)
                  var docRef2 = db.collection("Teams").doc(`${visitorTeam}`)
                  var docRef3 = db.collection("Leagues").doc(`${LeagueId}`)
                  var docRef4 = db.collection("Fixtures")
                  var docRef5 = db.collection("Players").doc(`${currentUser.uid}`).collection("Favorites").doc(`${fixtureId}`)

                  function VerifyProcessedData() {
                    if (TeamsVisitorProcessed === TeamCount && TeamsLocalProcessed === TeamCount && LeaguesProcessed === TeamCount && PredictionsProcessed === TeamCount && FavoriteProcessed === TeamCount) {
                      setIsLoading(false);
                      setLoadedDataFromApi(response.data);

                      db.collection("ExtraInformation").doc("DashboardLastCall")
                        .set({
                          date: todayString
                        })
                    }
                  }

                  docRef1.get().then((doc) => {
                    if (doc.exists) {
                      data.localTeam = doc.data().name;
                      data.logoLocalTeam = doc.data().logo;

                      TeamsLocalProcessed++
                      VerifyProcessedData();

                    } else {
                      // doc.data() will be undefined in this case
                      console.log("No such Team found!");
                      TeamsLocalProcessed++
                      VerifyProcessedData();
                    }
                  })
                    .catch((error) => {
                      console.log("Error getting document:", error);
                    });

                  docRef2.get().then((doc) => {
                    if (doc.exists) {
                      data.visitorTeam = doc.data().name;
                      data.logoVisitorTeam = doc.data().logo;

                      TeamsVisitorProcessed++
                      VerifyProcessedData();

                    } else {
                      // doc.data() will be undefined in this case
                      console.log("No such Team found!");
                      TeamsVisitorProcessed++
                      VerifyProcessedData();
                    }
                  }).catch((error) => {
                    console.log("Error getting document:", error);
                  });

                  docRef3.get().then((doc) => {
                    if (doc.exists) {
                      data.leagueName = doc.data().name;

                      LeaguesProcessed++
                      VerifyProcessedData();

                    } else {
                      // doc.data() will be undefined in this case
                      console.log("No such Team found!");

                      LeaguesProcessed++
                      VerifyProcessedData();
                    }
                  }).catch((error) => {
                    console.log("Error getting document:", error);
                  });

                  docRef4.get().then((doc) => {
                    if (doc.exists) {
                      data.predictionLocal = doc.data().predLocal;
                      data.predictionVisitor = doc.data().predVisitor;
                      data.predictionDraw = doc.data().predDraw;

                      PredictionsProcessed++
                      VerifyProcessedData();

                    } else {
                      fetch(`https://soccer.sportmonks.com/api/v2.0/predictions/probabilities/fixture/${fixtureId}?api_token=
                    YKAxRMxZIDeZMWQG3A0WvcgeUn0AbkeXDf2wDQNMM3i9kNpnZOa75RlBRGnp`)
                        .then((responsePredictions => {
                          return responsePredictions.json();
                        }))
                        .then((responsePredictions => {

                          console.log(responsePredictions)

                          // sometimes the predictions are not available trough the API 
                          if (responsePredictions.data.length === 0) {
                            data.predictionLocal = 0
                            data.predictionVisitor = 0
                            data.predictionDraw = 0
                          }
                          else {
                            data.predictionLocal = responsePredictions.data.predictions.home;
                            data.predictionVisitor = responsePredictions.data.predictions.away;
                            data.predictionDraw = responsePredictions.data.predictions.draw;
                          }



                          var teams = `${data.localTeam} - ${data.visitorTeam}`

                          docRef4.doc(`${fixtureId}`).set({
                            id: data.id,
                            teams: teams,
                            localTeam: data.localTeam,
                            visitorTeam: data.visitorTeam,
                            localTeamId: data.localteam_id,
                            visitorTeamId: data.visitorteam_id,
                            logoLocalTeam: data.logoLocalTeam,
                            logoVisitorTeam: data.logoVisitorTeam,
                            dateAndTime: data.time.starting_at.date_time,
                            date: data.time.starting_at.date,
                            time: data.time.starting_at.time,
                            timestamp: data.time.starting_at.timestamp * 1000,
                            league: data.leagueName,
                            isFavorite: false,
                            winnerTeamId: null,
                            isProcessed: false,
                            score: data.scores.ft_score,

                            predictionLocal: responsePredictions.data.length === 0 ? 0 : responsePredictions.data.predictions.home,
                            predictionVisitor: responsePredictions.data.length === 0 ? 0 : responsePredictions.data.predictions.away,
                            predictionDraw: responsePredictions.data.length === 0 ? 0 : responsePredictions.data.predictions.draw
                          })

                          PredictionsProcessed++
                          VerifyProcessedData();
                        }))
                    }
                  }).catch((error) => {
                    console.log("Error getting document:", error);
                  });

                  docRef5.get().then((doc) => {
                    if (doc.exists) {
                      data.isFavorite = true;

                      FavoriteProcessed++
                      VerifyProcessedData();

                    } else {
                      // doc.data() will be undefined in this case
                      data.isFavorite = false;

                      FavoriteProcessed++
                      VerifyProcessedData();
                    }
                  }).catch((error) => {
                    console.log("Error getting document:", error);
                  });

                })
              }
            }))

        }


      }))

    // OFFLINE ONLINE TOAST
    let connectionLostToast = document.getElementById('connectionLost')
    connectionLostToast.setAttribute('autohide', false)

    window.addEventListener('offline', function () {
      connectionLostToast.style.display = "block"
    });

    window.addEventListener('online', function () {
      connectionLostToast.style.display = "none"
    });


  }, [todayString, inTenDaysString, currentUser.uid])

  //if we are loading the data return loading .. 
  if (isLoading) {
    return (
      <>
        <div className="lds-circle" />
        <ConnectionToast />
      </>
    )
  }


  if (localStorage.getItem("ApiOrFirebaseOrNoMatches") === "NM") {
    return (
      <>
        <ConnectionToast />
        <div className="col-md-7 offset-md-1 pt-5">
          <h1 className="text-light text-center pt-5 mb-4 font-link-header">NO. MATCHES.
            <br /> GET. SOME. REST.</h1>
        </div>
      </>

    )
  }


  return (
    <div className='cntr'>
      <ConnectionToast />
      {/* soort van container aan de buikenkant, daarin komt de api om de match-elementen in een colom te brengen */}
      <div className="row g-0 justify-content-md-end rowwithmargin pt-5">
        <h1 className="col-md-10 mb-3 font-link-header2">
          UPCOMMING. MATCHES. ({loadedDataFromApi.length})
        </h1>

        {localStorage.getItem("ApiOrFirebaseOrNoMatches") === "API"

          ?

          loadedDataFromApi.map((data) => {

            console.log(loadedDataFromApi.length)
            var teams = `${data.localTeam} - ${data.visitorTeam}`

            return (
              <>
                <div key={data.id} className="col-md-9 col-sm-1 mb-4">
                  <Match
                    id={data.id}
                    key={data.id}
                    teams={teams}
                    localTeam={data.localTeam}
                    visitorTeam={data.visitorTeam}
                    localTeamId={data.localteam_id}
                    visitorTeamId={data.visitorteam_id}
                    dateAndTime={data.time.starting_at.date_time}
                    date={data.time.starting_at.date}
                    time={data.time.starting_at.time}
                    timestamp={data.time.starting_at.timestamp * 1000}
                    league={data.leagueName}
                    logoLocalTeam={data.logoLocalTeam}
                    logoVisitorTeam={data.logoVisitorTeam}
                    predictionLocal={data.predictionLocal}
                    predictionVisitor={data.predictionVisitor}
                    predictionDraw={data.predictionDraw}
                    isFavorite={data.isFavorite}
                    winnerTeamId={null}
                    isProcessed={false}
                    score={data.scores.ft_score}>
                  </Match>
                </div>
              </>
            )
          })

          :

          loadedDataFromApi.map((data) => {

            var teams = `${data.localTeam} - ${data.visitorTeam}`

            console.log(loadedDataFromApi.length)
            return (
              <>
                <div key={data.id} className="col-md-9 col-sm-1 mb-4">
                  <Match
                    id={data.id}
                    key={data.id}
                    teams={teams}
                    localTeam={data.localTeam}
                    visitorTeam={data.visitorTeam}
                    localTeamId={data.localTeamId}
                    visitorTeamId={data.visitorTeamId}
                    dateAndTime={data.dateAndTime}
                    date={data.date}
                    time={data.time}
                    timestamp={data.timestamp}
                    league={data.league}
                    logoLocalTeam={data.logoLocalTeam}
                    logoVisitorTeam={data.logoVisitorTeam}
                    predictionLocal={data.predictionLocal}
                    predictionVisitor={data.predictionVisitor}
                    predictionDraw={data.predictionDraw}
                    isFavorite={data.isFavorite}
                    winnerTeamId={data.winnerTeamId}
                    isProcessed={data.isProcessed}
                    score={data.score}>
                  </Match>
                </div>
              </>
            )
          })

        }
      </div>
    </div>
  )
}

export default Dashboard